export const Events = {
    GetContext: 'itero_shell_get-context',
    InitContext: 'itero_analytics_init-context',
    TokenExpired: 'itero_shell_token-expired',
    CompanyChanged: 'itero_everyone_company-changed',
    LanguageChanged: 'itero_everyone_language-changed',
    AppName: 'analytics'
}